<template>
    <div v-on-click-outside="() => close(true)" class="relative">
        <Button size="sm" type="button" :color="isSelected ? 'brand' : 'default'" @click="opened = !opened">
            {{ value.name }}
        </Button>
        <div
            v-if="opened"
            class="absolute left-0 z-20 w-screen max-w-xs p-2 mt-1 space-y-2 bg-white border border-gray-300 rounded shadow top-full"
        >
            <div class="absolute space-x-1 top-2 right-2">
                <Button v-if="showUseButton" type="button" variant="inline" size="xs" @click="selectPreset()"
                    >Použít</Button
                >
                <Button
                    v-if="isSelected"
                    type="button"
                    variant="inline"
                    size="xs"
                    color="danger"
                    @click="selectPreset(true)"
                    >Zrušit</Button
                >
            </div>
            <template v-for="variable in value.variables" :key="variable.key">
                <p class="text-xs">
                    {{ variable.name }}
                </p>
                <Datepicker v-if="variable.type === 'date'" v-model="variable.value" />
            </template>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, computed, toRefs, watch } from 'vue';
import { vOnClickOutside } from '@vueuse/components';

const emit = defineEmits(['select']);

interface Props {
    preset?: any;
    selectedPreset?: any;
}

const props = withDefaults(defineProps<Props>(), {
    preset: null,
    selectedPreset: null,
});

const { preset, selectedPreset } = toRefs(props);
const opened = ref(false);

const value = ref({
    key: preset.value.key,
    name: preset.value.name,
    type: preset.value.type,
    variables: preset.value.variables,
});

const isSelected = computed(() => {
    return selectedPreset.value && selectedPreset.value.key === preset.value.key;
});

const isFilled = computed(() => {
    return typeof value.value.variables.find((single) => !single.value) === 'undefined';
});

const isChanged = computed(() => {
    const usedVariables = selectedPreset.value ? selectedPreset.value.variables : [];
    const selectedVariables = value.value.variables;

    const usedValues = usedVariables.map((single) => single.value);
    const selectedValues = selectedVariables.map((single) => single.value);

    return usedValues.join('') !== selectedValues.join('');
});

const showUseButton = computed(() => {
    if (!isFilled.value) return false;

    if (!isSelected.value) return true;

    return isSelected.value && isChanged.value;
});

const selectPreset = (unset = false) => {
    emit('select', unset ? null : value.value);

    if (unset) {
        resetValues();
        close(true);
    } else {
        close();
    }
};

const resetValues = () => {
    const { variables } = value.value;
    value.value.variables = variables.map((single) => ({ ...single, value: null }));
};

const close = (withReset = false) => {
    if (withReset && !isSelected.value) {
        resetValues();
    }
    opened.value = false;
};

watch(selectedPreset, (selectedValue) => {
    if (isSelected.value && selectedValue) {
        value.value.variables = selectedValue.variables;
    }
});
</script>
